import * as React from 'react';
import { useField } from 'formik';
import { AccountWithName, EmailAccountLinkInput } from '../../../components/EmailAccountLinkInput';

interface EmailAccountPickerProps {
  name: string;
}

// Formik-bound account selector. Reuses EmailAccountLinkInput (which fetches accounts via
// getAllEmailAccounts) and stores the schedule's {id, email} account shape in the form.
export function EmailAccountPicker({ name }: EmailAccountPickerProps) {
  const [field, , helpers] = useField<{ id: string; email: string }>(name);

  const value: AccountWithName | null = field.value?.id
    ? { id: field.value.id, email: field.value.email, name: field.value.email, service: '' }
    : null;

  return (
    <EmailAccountLinkInput
      name={name}
      id={name}
      value={value}
      onChoose={(account) =>
        helpers.setValue(account ? { id: account.id, email: account.email } : { id: '', email: '' })
      }
    />
  );
}
